export const menu = [
  {
    text: "Árboles",
    icon: "tile-thumb",
    link: "/dashboard",
  },
  {
    icon: "grid-alt",
    text: "Maestros",
    active: false,
    subMenu: [
      {
        text: "Areás de aliados",
        link: "/allianzer-areas",
      },
      {
        text: "Nombres comunes",
        link: "/common-names",
      },
      {
        text: "Familias",
        link: "/family",
      },
      {
        text: "Especies",
        link: "/specie",
      },
      {
        text: "Nombre de voluntarios",
        link: "/volunteer-name",
      },
      {
        text: "Ubicaciones",
        link: "/location",
      },
      {
        text: "Tipos de árbol",
        link: "/tree-types",
      },
    ],
  },
  {
    icon: "presentation",
    text: "Pagina",
    active: false,
    subMenu: [
      {
        text: "Información",
        link: "/configurations",
      },
      {
        text: "Estadísticas",
        link: "/graph",
      },
    ],
  },
  {
    text: "Usuarios",
    icon: "users",
    link: "/users",
  },
];
export const headermenu = [
  {
    text: "Dashboards",
    link: "#",
    active: false,
    subMenu: [
      {
        text: "Default Dashboard",
        link: "/",
      },
      {
        text: "Sales Dashboard",
        link: "/sales",
      },
      {
        text: "Invest Dashboard",
        link: "/invest",
      },
      {
        text: "Crypto Dashboard",
        link: "/crypto",
      },
      {
        text: "Analytics Dashboard",
        link: "/analytics",
      },
    ],
  },
  {
    text: "Apps",
    link: "#",
    active: false,
    subMenu: [
      {
        text: "Messages",
        link: "/app-messages",
      },
      {
        text: "Inbox / Mail",
        link: "/app-inbox",
      },
      {
        text: "File Manager",
        link: "/app-file-manager",
      },
      {
        text: "Chats / Messenger",
        link: "/app-chat",
      },
      {
        text: "Calendar",
        link: "/app-calender",
      },
      {
        text: "Kanban Board",
        link: "/app-kanban",
      },
    ],
  },
  {
    text: "Components",
    link: "/components",
  },
];

export const copywritermenu = [
  {
    heading: "Dashboards",
  },
  {
    text: "Dashboard",
    icon: "presentation",
    link: "/copywriter",
  },
  {
    text: "Documents",
    icon: "folder-list",
    subMenu: [
      {
        text: "Saved",
        link: "/copywriter/document-saved",
      },
      {
        text: "Drafts",
        link: "/copywriter/document-drafts",
      },
    ],
  },
  {
    text: "Editor",
    icon: "edit",
    link: "/copywriter/document-editor",
  },
  {
    text: "Templates",
    icon: "layers",
    link: "/copywriter/templates",
  },
  {
    text: "History",
    icon: "clock",
    link: "/copywriter/history",
  },
  {
    text: "Pricing Plans",
    icon: "sign-usdc",
    link: "/copywriter/pricing-plans",
  },
  {
    text: "Profile",
    icon: "user",
    link: "/copywriter/profile",
  },
  {
    text: "Payments",
    icon: "wallet",
    newTab: true,
    link: "/copywriter/payment",
  },
  {
    heading: "Return To",
  },
  {
    text: "Main Dashboard",
    icon: "dashlite-alt",
    link: "/",
  },
  {
    text: "All Components",
    icon: "layers-fill",
    link: "/components",
  },
];

export const copywriterheadermenu = [
  {
    text: "Documents",
    subMenu: [
      {
        text: "Saved",
        link: "/copywriter/document-saved",
      },
      {
        text: "Drafts",
        link: "/copywriter/document-drafts",
      },
    ],
  },
  {
    text: "Editor",
    link: "/copywriter/document-editor",
  },
  {
    text: "Templates",
    link: "/copywriter/templates",
  },
];

export default menu;
